'use strict';

angular.module('shiftTraderApp')
    .directive('disableAnimation', function ($animate) {
      return {
        restrict: 'A',
        compile: function(elem) {
          $animate.enabled(false, elem);
        }
      };
    });
